import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, Col, FormGroup } from "react-bootstrap";
import * as Api from '../../../../../../api/cp/widgetRegistration';
import WidgetsList from "../../components/WidgetsList";

const WidgetsConstructor = ({event}) => {
    const history = useHistory();
    const [widgetsList, setWidgetLists] = useState([]);

    useEffect(() => {
        fetchRegistrationWidgets();
    }, []);

    async function fetchRegistrationWidgets() {
        try {
            const response = await Api.getWidgetsRegistration(event.eventKey);
            setWidgetLists(response);
        } catch (error) {
            console.error(error);
        }
    }

    const handleCreateWidget = async () => {
        try {
            const response = await Api.createWidgetRegistration(event.eventKey);
            setWidgetLists((prevState) => [...prevState, response]);
            history.push(`/event/${event.eventPassword}/widgets/new-registration/${response.widgetKey}`)
        } catch (error) {
            console.error(error);
        }
    };

    const handleEditWidget = async (model) => {
        try {
            await Api.updateWidgetRegistration(model.widgetKey, model);
            fetchRegistrationWidgets();
        } catch (error) {
            console.error(error);
        }
    };

    const handleDeleteWidget = async (widgetKey) => {
        try {
            await Api.deleteWidgetRegistration(widgetKey);
            fetchRegistrationWidgets();
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <Col xs={12}>
            <FormGroup>
                <Button
                    bsStyle="primary"
                    onClick={handleCreateWidget}
                >
                    Создать свой виджет
                </Button>
            </FormGroup>

            <WidgetsList
                list={widgetsList}
                onEdit={handleEditWidget}
                onDelete={handleDeleteWidget}
            />
        </Col>
    )
};

export default WidgetsConstructor;
